import React, { useState } from 'react';
import { Grid, TextField, Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { useNavigate, Link } from 'react-router-dom';
import s1 from '../../images/shape.png';
import './style.scss';

const ForgotPassword = () => {
  const [value, setValue] = useState({ email: '' });
  const [validator] = useState(new SimpleReactValidator({ className: 'errorMessage' }));
  const navigate = useNavigate();

  const changeHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const submitForm = (e) => {
    e.preventDefault();

    if (validator.allValid()) {
      // ✅ Mock reset flow — replace with actual API call
      toast.success('Password reset link sent to your email!');
      setValue({ email: '' });
      validator.hideMessages();

      // Redirect after success
      setTimeout(() => navigate('/login'), 1500);
    } else {
      validator.showMessages();
      toast.error('Please fill in a valid email address!');
    }
  };

  return (
    <Grid className="loginWrapper">
      <Grid className="loginForm">
        <h2>Forgot Password</h2>
        <p>Enter your email to reset your password</p>

        <form onSubmit={submitForm}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                className="inputOutline"
                fullWidth
                placeholder="E-mail"
                value={value.email}
                variant="outlined"
                name="email"
                label="E-mail"
                InputLabelProps={{ shrink: true }}
                onChange={changeHandler}
                onBlur={changeHandler}
              />
              {validator.message('email', value.email, 'required|email')}
            </Grid>

            <Grid item xs={12}>
              <Grid className="formFooter">
                <Button
                  fullWidth
                  className="cBtn cBtnLarge cBtnTheme"
                  type="submit"
                >
                  Resend Password
                </Button>
              </Grid>

              <Grid className="loginWithSocial">
                <Button className="facebook"><i className="fa fa-facebook" /></Button>
                <Button className="twitter"><i className="fa fa-twitter" /></Button>
                <Button className="linkedin"><i className="fa fa-linkedin" /></Button>
              </Grid>

              <p className="noteHelp">
                Remember your password? <Link to="/login">Return to Sign In</Link>
              </p>
            </Grid>
          </Grid>
        </form>

        <div className="shape-img">
          <img src={s1} alt="Decoration shape" />
        </div>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
